import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))
function GenAi_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <GenAi_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <GenAi_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function GenAi_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What is generative AI?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Generative AI refers to algorithms that can create new content,
              such as text, images, music, or videos, by learning patterns from
              existing data. Examples include GPT (for text generation) and
              DALL·E (for image generation).
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How does generative AI work?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Generative AI works by training on large datasets using deep
              learning models, such as neural networks. The models learn
              patterns and features in the data and then use that knowledge to
              generate new, similar content. For example, GPT models generate
              text by predicting the next word in a sequence based on prior
              text.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How is generative AI different from traditional AI?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Traditional AI is often designed to recognize patterns or make
              decisions based on existing data (e.g., classifying images or
              making predictions). In contrast, generative AI focuses on
              creating new, original content. While traditional AI typically
              reacts to inputs, generative AI actively generates novel outputs.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What is the difference between Generative AI and Discriminative
              AI?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Generative AI creates new content based on patterns learned from
              training data, while discriminative AI focuses on classifying or
              categorizing input data. For example, a discriminative model might
              classify images as cats or dogs, whereas a generative model could
              create new images of cats or dogs.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How is Generative AI trained?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Generative AI models are trained using large datasets. For text,
              models like GPT are trained on vast amounts of text from books,
              websites, and other written material. For images, GANs are trained
              on millions of images to learn visual patterns. The training
              involves adjusting model parameters to minimize the difference
              between generated content and real data.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}
export default GenAi_FAQ_page
